class Validator {

  isPhoneNumber(phoneNumber: string): boolean {
    const phoneRegex = /^1[3456789]\d{9}$/;
    return phoneRegex.test(phoneNumber);
  }

}

export const validator = new Validator();
